import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../../../syntax/index.js";
import { Value } from "../../../value.js";
import { Position } from "./position.js";
const { map, either, pair, option, right } = Parser;
/**
 * @internal
 */
export class Corner extends Value {
    static of(vertical, horizontal) {
        return new Corner(vertical, horizontal);
    }
    _vertical;
    _horizontal;
    constructor(vertical, horizontal) {
        super("corner", false);
        this._vertical = vertical;
        this._horizontal = horizontal;
    }
    get vertical() {
        return this._vertical;
    }
    get horizontal() {
        return this._horizontal;
    }
    resolve() {
        return this;
    }
    equals(value) {
        return (value instanceof Corner &&
            value._vertical === this._vertical &&
            value._horizontal === this._horizontal);
    }
    hash(hash) {
        hash.writeString(this._vertical).writeString(this._horizontal);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            vertical: this._vertical,
            horizontal: this._horizontal,
        };
    }
    toString() {
        return `to ${this._vertical} ${this._horizontal}`;
    }
}
/**
 * @internal
 */
(function (Corner) {
    const parseCorner = (side1, side2) => pair(side1, right(option(Token.parseWhitespace), side2));
    /**
     * {@link https://drafts.csswg.org/css-images/#typedef-side-or-corner}
     *
     * @internal
     */
    Corner.parse = right(Token.parseIdent("to"), right(Token.parseWhitespace, either(map(parseCorner(Position.parseVertical, Position.parseHorizontal), ([vertical, horizontal]) => Corner.of(vertical, horizontal)), map(parseCorner(Position.parseHorizontal, Position.parseVertical), ([horizontal, vertical]) => Corner.of(vertical, horizontal)))));
})(Corner || (Corner = {}));
//# sourceMappingURL=corner.js.map